import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/buchungsheld-theme/components/tr-tooltip.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import { Language } from '@adornis/translation-core/languages.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('bh-language-switch')
export class BHLanguageSwitch extends BuchungsheldLitElement {
  @state() private readonly _language = new RXController(this, globalLanguageSubject);

  override render() {
    return html`
      <tr-button-small
        .color=${this.colors.tone.black}
        mode="outline"
        .action=${() =>
          globalLanguageSubject.next(this._language.value === Language.GERMAN ? Language.ENGLISH : Language.GERMAN)}
      >
        <tr-text>${this._language.value.toLocaleUpperCase()}</tr-text>
        <tr-tooltip .text=${this._translation.translate('change_language')}></tr-tooltip>
      </tr-button-small>
    `;
  }
}
